import { routesMap } from '../../routes/AppRoutes';
import HeroSection from '../conduct-risk/HeroSection';

const BannerAltreFontiPage = () => {
  return (
    <HeroSection
      title="Altre Fonti"
      description="In questa sezione puoi gestire e configurare le altre fonti dati."
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: '#', title: 'Altre fonti dati' },
      ]}
    />
  );
};

export default BannerAltreFontiPage;
